
import appUpdateBox from "./components/add-file.vue";
import { Component, Vue } from "vue-property-decorator";
import { delOneModel } from "@/api/api-basic";
import { getOptionList, optionKey } from "@/api/api-dict";
import { objAny } from "@/common/common-interface";
import i18n from "@/config/i18n";
import { getAppUpdateInfo } from "@/api/api-app-update";
import { APP_UPDATE_STATUS, APP_TYPE_OPS } from "@/constants/constants";

@Component({
  components: { appUpdateBox }
})
export default class EquipmentModel extends Vue {
  private APP_UPDATE_STATUS = APP_UPDATE_STATUS;
  private APP_TYPE_OPS = APP_TYPE_OPS;
  private ObjectData = {};
  // private test: string = "light";
  private privilege: objAny = {};
  private appUpdateBox: objAny = {};
  private piModelAdd: objAny = {};
  private piNewAdd: objAny = {};

  private modelList = [];
  private oprList = [];
  private devTypeList: object[] = [];

  private total = 0;
  private time: object[] = [];

  private formInline: objAny = {
    oprName: "",
    status: "",
    appType: ""
  };
  private ruleInline = {};
  private loading = false;
  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      type: "selection",
      width: 40,
      align: "center"
    },
    {
      title: i18n.t("appUpdate.table.compatibleOperator"),
      key: "oprName",
      resizable: true,
      minWidth: 130,
      slot: "oprName"
    },
    {
      title: i18n.t("appUpdate.table.type"),
      key: "type",
      resizable: true,
      minWidth: 130,
      slot: "type"
    },
    {
      title: i18n.t("appUpdate.table.remindUpgradeVersion"),
      key: "remindUpgradeVersion",
      resizable: true,
      minWidth: 130,
      slot: "remindUpgradeVersion"
    },
    {
      title: i18n.t("appUpdate.table.mandatoryUpgradeVersion"),
      resizable: true,
      minWidth: 130,
      slot: "forcedUpgradeVersion"
    },
    {
      title: i18n.t("appUpdate.table.remarks"),
      key: "remarks",
      resizable: true,
      minWidth: 120,
      slot: "remarks"
    },
    {
      title: i18n.t("equipmentModel.updateTime"),
      key: "modifyTime",
      resizable: true,
      minWidth: 140,
      // slot: "modifyTime",
      render: (h: Function, params: objAny) => {
        if (params.row.modifyTime) {
          return h(
            "div",
            this.$common.userDate(
              new Date(params.row.modifyTime),
              "yyyy-MM-dd HH:MM:SS"
            )
          );
        } else {
          return h("div", "--");
        }
      }
    },
    {
      title: i18n.t("appUpdate.table.status"),
      minWidth: 130,
      slot: "status"
    },
    {
      title: i18n.t("operation"),
      resizable: true,
      minWidth: 160,
      slot: "action"
    }
  ];
  private selectList: object[] = [];

  public sortChange(column: objAny): void {
    if (column.order === "normal") {
      this.formInline.globalOrder = "";
    } else {
      this.formInline.globalOrder =
        "name=" + column.key + ",age=" + column.order;
    }
    this.getTableList();
  }

  async getOptionList() {
    const ret = await getOptionList([optionKey.devTypeList]); //请求字典
    this.devTypeList = ret[optionKey.devTypeList]; // 客户名称
  }

  public openCopy(item) {
    this.ObjectData = { ...item, openType: "copy" };
  }

  public openEdit(item) {
    this.ObjectData = { ...item, openType: "edit" };
  }

  public selectItem(list: object[]) {
    const chooseList: object[] = [];
    list.map((item: objAny) => {
      chooseList.push(item.deviceModelPkId);
    });
    this.selectList = chooseList;
  }

  // public queryAlarm(): void {
  //   this.getTableList();
  // }
  public addEquipment(): void {
    this.piModelAdd.open();
  }

  public addNewAbout(): void {
    this.$refs.appUpdateBox.add();
  }

  public queryClick(): void {
    this.getTableList();
  }

  public pageChange(val: number): void {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }

  public sizeChange(val: number): void {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }

  public detailBtn(item: objAny): void {
    this.piNewAdd.open(item, "detail");
  }

  public updModel(item: objAny): void {
    this.piNewAdd.open(item, "update");
  }

  public deleteModel(item: objAny): void {
    this.$Modal.confirm({
      title: i18n.t("tips") + "",
      content: i18n.t("equipmentModel.delDeviceModelName") + "",
      onOk: () => {
        this.delItemModel(item.deviceModelPkId);
      }
    });
  }

  public deleteSome(): void {
    if (this.selectList.length === 0) {
      this.$Message.error(i18n.t("equipmentModel.minSelectItem") + "");
    } else {
      this.$Modal.confirm({
        title: i18n.t("tips") + "",
        content: i18n.t("equipmentModel.delDeviceModelName") + "",
        onOk: () => {
          this.delItemModelSome();
        }
      });
    }
  }

  async getTableList(): Promise<void> {
    // if (this.formInline.startTime == "" || this.formInline.endTime == "") {
    //   this.$Message.error("更新时间不能为空 !");
    //   return;
    // }
    this.loading = true;
    const ret = await getAppUpdateInfo(this.formInline);
    if (ret.status === this.$config.apiStatus) {
      this.total = ret.total;
      this.tableList = ret.data;
    }
    this.loading = false;
  }

  // 删除
  async delItemModel(deviceModelPkId: string): Promise<void> {
    const deviceModelPkIds = [deviceModelPkId];
    const ret = await delOneModel({ deviceModelPkIds });
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("deleteSuccess"));
      this.getTableList();
    }
  }

  // 批量删除
  async delItemModelSome(): Promise<void> {
    const ret = await delOneModel({ deviceModelPkIds: this.selectList });
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("deleteSuccess"));
      this.getTableList();
    }
  }

  private timeFn(val: objAny): void {
    if (val[0] !== "" && val[1] !== "") {
      this.formInline.startTime = this.$common.userDate(val[0]).split(" ")[0];
      this.formInline.endTime = this.$common.userDate(val[1]).split(" ")[0];
    } else {
      this.formInline.startTime = "";
      this.formInline.endTime = "";
    }
  }

  public invalidateHandle(item, status) {
    // 检测tableList 有多少个status的值为1，如果只有一个值，继续往下走，否则就弹框并停止往下走，因为生效状态只能有一个
    // 计算状态为1的条目数量
    const activeItemsCount = this.tableList.filter(
      row => row.status === 1 && row.appType == item.appType
    ).length;

    // 检查是否只有一个活跃条目
    if (activeItemsCount >= 1 && item.status === 0) {
      this.$Message.error(this.$t("appUpdate.msg.error"));
      return;
    }
    this.ObjectData = {
      oprPkId: item.pkId,
      status: status
    };
    if (item.status == 0) {
      setTimeout(() => {
        this.$refs.appUpdateBox.invalidate();
      });
    } else if (item.status == 1) {
      this.$Modal.confirm({
        title: i18n.t("tips") + "",
        content: i18n.t("appUpdate.inValidContent") + "",
        onOk: () => {
          this.$refs.appUpdateBox.invalidate();
        },
        onCancel: () => {
          // this.$Message.info("Clicked cancel");
        }
      });
    }
  }

  public refreshData() {
    this.getOptionList();
    this.getTableList();
  }

  public created(): void {
    // const startTime = this.$common.thisTimes("yyyy-MM");
    // const endTime = this.$common.thisTimes("yyyy-MM-dd");
    // this.formInline.startTime = startTime + "-01";
    // this.formInline.endTime = endTime;
    // this.time = [this.formInline.startTime, this.formInline.endTime];
    this.getOptionList();
    this.getTableList();
    // this.searchInitData();
  }

  mounted() {
    this.$nextTick((): void => {
      this.piModelAdd = this.$refs["piModelAdd"];
      this.piNewAdd = this.$refs["piNewAdd"];
    });
    this.privilege = this.$route.meta.privilegeVoObj;
  }
}
